import React from "react";
import { useNavigate } from "react-router-dom";
import CustomViewButton from "../../CustomComponent/custom_view_button";
import { useState } from "react";
import { BsJournalArrowUp } from "react-icons/bs";

const tableHead = [
  "Sr.",
  "Recipe Image",
  "Recipe Name",
  "Price",
  "In Stock",
  "Actions",
];
const EpgRecipeTable = ({ data, currentPage, itemsPerPage }) => {
  const navigate = useNavigate();
  const [variantRows, setVariantRows] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const goToView = (id) => {
    // id = getId(id);
    navigate(`/view-epg-recipe/${id}`);
  };

  /* ---------- In Stock Details Model ---------- */

  const openInstockUpdateModal = (item) => {
    const variantsWithQty = item.pmg_product_variants.map((v) => ({
      variantId: v?.variantId || v.id,
    //   productId: v?.productId,
      productName: v?.pmg_product?.title,
      title: v?.title,
      price: v?.price,
      quantity: v?.pmg_recipe_variants?.quantity,
      unit: v?.unit || "",
    }))

    console.log("variantsWithQty", variantsWithQty);

    setSelectedProduct(item);
    setVariantRows(variantsWithQty);
  };

  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        {/* <thead>
          <tr>
            {tableHead?.map((item, index) => {
              return <th key={index}>{item}</th>;
            })}
          </tr>
        </thead> */}
        <thead>
          <tr>
            <th style={{ minWidth: "180px" }}>SR./ IMAGE</th>
            <th style={{ minWidth: "300px" }}>PRODUCT</th>
            <th style={{ minWidth: "180px" }}>DETAILS / PRICE</th>
            <th style={{ minWidth: "180px" }}>INSTOCK / THRESHOLD LIMIT</th>
            <th className="text-center" style={{ minWidth: "180px" }}>
              ACTIONS
            </th>
          </tr>
        </thead>
        <tbody>
          {data?.map((item, index) => {
            const Index = (currentPage - 1) * itemsPerPage + index + 1;
            return (
              <tr key={item.id} className="text-uppercase fs-5">
                {/* IMAGE */}
                <td>
                  <img
                    src={item.image}
                    alt={item.title}
                    width="120"
                    height="120"
                    className="rounded border"
                    style={{
                      objectFit: "cover",
                    }}
                  />
                </td>

                {/* PRODUCT DETAILS */}
                <td>
                  <div className="fw-bold fs-3">{item.title}</div>

                  <div className="text-muted mt-2">
                    Product ID :
                    <span className="badge bg-primary-lt ms-2">{item.id}</span>
                  </div>

                  <div className="mt-2">
                    <span className="badge bg-green-lt me-2">
                      {item.subtitle || "EPG"}
                    </span>

                    <span className="badge bg-azure-lt">
                      {item.status || "ACTIVE"}
                    </span>
                  </div>

                  <div className="mt-2 text-secondary">
                    Products :
                    <b className="ms-2">
                      {item.pmg_product_variants?.length || 0}
                    </b>
                  </div>
                </td>

                {/* PRICE */}
                <td>
                  <div className="mb-0 pb-0">
                    <p className="mb-1 pb-1">
                      {item?.description.substring(0, 100) + "..."
                        }
                    </p>
                  </div>
                  <div className="mb-1 pb-1">
                    <span className="badge bg-yellow-lt">
                      {item.tags || "N/A"}
                    </span>
                  </div>
                  <div
                    className="badge bg-green text-white fs-3 px-3 py-1"
                    style={{ fontWeight: "900" }}
                  >
                    ₹{item?.totalPrice || 0}
                  </div>
                </td>

                {/* STOCK */}
                <td>
                  <div className="mt-2 mb-2">
                    <span className="fs-4" style={{ fontWeight: "700" }}>
                      INSTOCK :{" "}
                      {item?.pmg_product_variants?.[0]?.inventory_quantity} /
                      100 {item?.pmg_product_variants?.[0]?.unit || ""}
                    </span>
                  </div>
                  <button
                    className="btn btn-sm px-3 btn-primary"
                    // style={{
                    //   fontSize: "11px",
                    //   fontWeight: "600",
                    //   whiteSpace: "nowrap",
                    // }}
                    data-bs-toggle="modal"
                    data-bs-target="#modal-stock-details"
                    onClick={() => openInstockUpdateModal(item)}
                  >
                    <BsJournalArrowUp className="me-1" />
                    View Products
                  </button>
                </td>

                {/* ACTIONS */}

                <td>
                  <div className="row g-2">
                    <div className="col-12">
                      <CustomViewButton onClick={() => goToView(item.id)} />
                    </div>

                    <div className="col-12">
                      <button
                        className="btn btn-sm px-3 btn-primary"
                        onClick={() => navigate(`/edit-epg-recipe/${item.id}`)}
                        style={{
                          fontSize: "12px",
                          fontWeight: "600",
                          whiteSpace: "nowrap",
                        }}
                      >
                        <BsJournalArrowUp className="me-1" />
                        Edit Recipe
                      </button>
                    </div>
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      {/* ---------- IN STOCK MODAL ---------- */}
      <div
        className="modal modal-blur fade"
        id="modal-stock-details"
        tabIndex="-1"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            {/* HEADER */}
            <div className="modal-header">
              <h5 className="modal-title">Stock Details</h5>

              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>

            {/* BODY */}
            <div className="modal-body">
              {/* PRODUCT INFO */}
              <div className="mb-4">
                <h1 style={{ color: "green" }}> {selectedProduct?.title}</h1>

                <p>{selectedProduct?.description}</p>
              </div>

              {/* VARIANT TABLE */}
              <div className="table-responsive">
                <table className="table table-bordered align-middle">
                  <thead className="table-light">
                    <tr>
                      <th style={{ width: "40%" }}>Sr</th>
                      <th style={{ width: "40%" }}>Product Name</th>
                      <th style={{ width: "30%" }}>Price</th>
                      <th style={{ width: "30%" }}>Quantity</th>
                      {/* <th style={{ width: "30%" }}>Total Cost</th> */}
                    </tr>
                  </thead>

                  <tbody>
                    {variantRows?.map((v, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{`${v.productName} (${v?.title})`  || "Product"}</td>

                        <td>
                          <div
                            className="badge bg-lime text-lime-fg fs-3"
                            style={{ fontWeight: "bold" }}
                          >
                            ₹{v?.price || 0}
                          </div>
                        </td>

                        <td>
                          {v?.quantity || 0}
                          &nbsp;{v?.unit || ""}
                        </td>
                        {/* <td>₹{v?.quantity * v?.price || 0}</td> */}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            {/* FOOTER */}
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default EpgRecipeTable;
